/* cf-quote-header-label.js - Click Fencing, 2026-09-02
 *
 * Pete: the quote-review header shows "FRAMELESS GLASS FENCING" above a quote that is not
 * frameless glass.
 *
 * ---------------------------------------------------------------------------------------
 * WHY. It is hardcoded in the page template. Straight out of the server HTML for
 * /pages/quote-review:
 *
 *     <p class="qr-header__eyebrow">Frameless Glass Fencing</p>
 *     <h1 class="qr-header__title" id="qr-quote-name">Your Quote</h1>
 *
 * The TITLE has an id and gets set per quote - it correctly read "Flat-Top Quote 1" when this
 * was found. The EYEBROW above it has no id, is never touched by quote-review.js, and so says
 * "Frameless Glass Fencing" for every quote on the site. Seen live: a Flat-Top quote for
 * $580.11 sitting under a Frameless Glass heading.
 *
 * That is the first line of the last page a customer reads before paying, and it names the
 * wrong product. Cheap to fix, and worth fixing for exactly that reason.
 *
 * HOW. Take the product from the active saved-quote pill's data-calc-type, which is the same
 * value the pills and the preview badge already use. If that is missing, fall back to reading
 * the quote title, which carries the product in its name ("Flat-Top Quote 1").
 *
 * IF WE CANNOT TELL, WE LEAVE IT ALONE. Writing a confident wrong label is worse than the bug
 * being fixed, so an unrecognised quote keeps whatever the template rendered.
 *
 * Display only - no quote, price, product or cart line is touched.
 */
(function () {
  'use strict';

  if (window.__cfQuoteHeaderLabel) return;
  window.__cfQuoteHeaderLabel = true;

  var path = (location.pathname || '/').replace(/\/+$/, '') || '/';
  if (path !== '/pages/quote-review') return;

  /* Keyed on the calcType the pills already carry. */
  var BY_TYPE = {
    frameless: 'Frameless Glass Fencing',
    flattop: 'Flat Top Fencing',
    blade: 'Blade Fencing',
    perfmesh: 'PerfMesh Fencing'
  };

  function fromTitle(name) {
    if (/flat[\s-]?top/i.test(name)) return BY_TYPE.flattop;
    if (/blade/i.test(name)) return BY_TYPE.blade;
    if (/perf|mesh/i.test(name)) return BY_TYPE.perfmesh;
    if (/frameless|glass/i.test(name)) return BY_TYPE.frameless;
    return null;
  }

  function wanted() {
    /* MIXED FENCE JOB (cf-job.js, 2026-09-23): a job is more than one fence, so naming
       it after whichever pill happens to be first would name the wrong product — the
       exact fault this file was written to fix. */
    try {
      if (window.CF_JOB && window.CF_JOB.isOn()) {
        var job = window.CF_JOB.merge();
        if (job && job.fences && job.fences.length) return job.fences.join(' + ') + ' Fencing';
      }
    } catch (e) {}

    var pill = document.querySelector('.qr-quote-pill.is-active') ||
               document.querySelector('.qr-quote-pill');
    var t = (pill && pill.dataset && pill.dataset.calcType) ? String(pill.dataset.calcType) : '';
    var label = BY_TYPE[t.toLowerCase()];
    if (label) return label;

    var nameEl = document.getElementById('qr-quote-name');
    return nameEl ? fromTitle(nameEl.textContent || '') : null;
  }

  function apply() {
    try {
      var eb = document.querySelector('.qr-header__eyebrow');
      if (!eb) return;
      var label = wanted();
      if (!label) return;                                  /* cannot tell - leave it be */
      if ((eb.textContent || '').trim() !== label) eb.textContent = label;
    } catch (e) {}
  }

  function start() {
    apply();
    try {
      var host = document.getElementById('qr-content') || document.body;
      if (window.MutationObserver) {
        var t = null;
        new MutationObserver(function () {
          if (t) clearTimeout(t);
          t = setTimeout(apply, 80);
        }).observe(host, { childList: true, subtree: true, characterData: true });
      }
    } catch (e) {}

    /* The quote is hydrated after load and again whenever a pill is clicked. */
    var n = 0;
    (function tick() {
      if (n++ > 60) return;
      apply();
      setTimeout(tick, 500);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  try { console.log('[cf-quote-header-label] installed'); } catch (e) {}
})();
